// Utils
import { setSessionStorageItem } from 'utils';
// Services
import * as dispatcherApi from 'services/manufacturingV1/dispatcher';
import * as organisationApi from 'services/manufacturingV1/organisations';
import { getApplicationStatus } from 'services/productionV1/applicationStatus';
// Types
import { APIResponseProps } from 'types/global';
import * as types from './types'
// Actions
import * as appActions from '../actions';
// Flags
import * as appConstants from '../statusFlags';

export async function getAppStatus({ dispatch }:{ dispatch: Function }) {
  const { response, errorMessage }:APIResponseProps = await getApplicationStatus();
  if (response) {
    const { applicationStatus } = response;
    dispatch(appActions.setApplicationStatus(applicationStatus));
  }
  if (errorMessage) {
    // eslint-disable-next-line no-console
    console.log(errorMessage);
  }
}

export async function postDispatcherTrigger({ dispatch, supplierId, creates, updates }:types.DefaultPostProps) {
  dispatch(appActions.setAppState(appConstants.GET_PRINTERS_LOADING));
  const {
    errorMessage,
  }:APIResponseProps = await dispatcherApi.postDispatcherTrigger(supplierId, creates, updates);

  if (errorMessage){
    dispatch(appActions.setAppState(appConstants.GET_DISPATCHER_TRIGGER_ERROR));
    dispatch(appActions.addNotification({
      label: errorMessage,
      type: 'error',
    }))
  } else {
    dispatch(appActions.setAppState(appConstants.GET_DISPATCHER_TRIGGER_SUCCESS));
    dispatch(appActions.addNotification({
      label: 'Dispatcher Triggered Successfully',
      type: 'success',
    }));
  }
}

export async function getOrganisations({ dispatch }:types.DefaultGetProps) {
  dispatch(appActions.setAppState(appConstants.GET_PRINTERS_LOADING));
  const {
    errorMessage,
    response,
  }:APIResponseProps = await organisationApi.getOrganisations();

  if (response) {
    dispatch(appActions.setSupplierId(response.organisation));
    dispatch(appActions.setAppState(appConstants.GET_SUPPLIERID_SUCCESS));
  }
  if (errorMessage){
    dispatch(appActions.setAppState(appConstants.GET_SUPPLIERID_ERROR));
    dispatch(appActions.addNotification({
      label: errorMessage,
      type: 'error',
    }))
  }
}

export async function setDefaultPrinter({ appDispatch, printerName }:{ appDispatch: Function, printerName: string }) {
  setSessionStorageItem({ key: 'defaultPrinter', item: printerName });
  appDispatch(appActions.setDefaultPrinter(printerName));
}